import { Injectable } from '@angular/core';
import { CustomerCompanyQuery } from 'app/backend/api';

@Injectable()
export class CustomerCompanyParams {

    public orderBy: 'name' | 'country' = 'name';
    public searchValue = '';
    public selectedApplication = '';

    public query: CustomerCompanyQuery = {
        search: '',
        applicationId: '',
        orderBy: 'name'
    };
}
